import axios from 'axios'
import store from '../store'

let configApi = require('../../config.json')[process.env.NODE_ENV]
const API_URL = configApi.VUE_APP_API;

let config = {
  headers: {  
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers':'X-Requested-With'
  }
};

let router = "city";

export class Cities {
  constructor() {
    axios.defaults.headers.common['x-access-token'] = store.state.authData.token
  }

  /**
   * get all cities
   * @param {object} params filters, limit, page size
   */
  GetCities(params) {
    let url = params != undefined ? `${API_URL}/city/${params}` : `${API_URL}/city`;

    return axios.get(url)
      .then(response => response.data)
      .catch((error) => {
        if (error.response && error.response.data) {
          return error.response.data
        } else {
          return {
            error: 'Error de conexión',
            message: 'No se pudo conectar con el servidor'
          }
        }
      })
  }

  /**
   * get city by rid
   * @param {string} rid
   */
  GetCity(rid) {
    let url = `${API_URL}/city/${rid}`

    return axios.get(url)
      .then(response => response.data)
      .catch((error) => {
        //console.log(error.response)
        if (error.response && error.response.data) {
          error.response.data.error = error.response.data.message
          return error.response.data
        } else {
          // Manejar el caso cuando no hay respuesta del servidor
          return {
            error: 'Error de conexión',
            message: 'No se pudo conectar con el servidor'
          }
        }
      })
  }

  /**
   * put city by rid update
   * @param {string} rid
   */
  PutCity(rid, data) {
    let url = `${API_URL}/city/${rid}`

    return axios.put(url, data)
      .then(response => response.data)
      .catch((error) => {
        if (error.response && error.response.data) {
          return error.response.data
        } else {
          return {
            error: 'Error de conexión',
            message: 'No se pudo conectar con el servidor'
          }
        }
      })
  }

  /**
   * post city create
   * @param {string} rid
   */
  PostCity(data) {
    let url = `${API_URL}/city`

    return axios.post(url, data)
      .then(response => response.data)
      .catch((error) => {
        if (error.response && error.response.data) {
          return error.response.data
        } else {
          return {
            error: 'Error de conexión',
            message: 'No se pudo conectar con el servidor'
          }
        }
      })
  }

  /**
   * delete city remove
   * @param {string} rid
   */
  DeleteCity(rid) {
    let url = `${API_URL}/city/${rid}`

    return axios.delete(url)
      .then(response => response.data)
      .catch((error) => {
        if (error.response && error.response.data) {
          return error.response.data
        } else {
          return {
            error: 'Error de conexión',
            message: 'No se pudo conectar con el servidor'
          }
        }
      })
  }

  filterCityByCountry(rid){
    let url = `${API_URL}/cityfilter?country=${rid}`

      return axios.get(url)
        .then(response => response.data)
        .catch((error) => {
          if (error.response && error.response.data) {
            return error.response.data
          } else {
            return {
              error: 'Error de conexión',
              message: 'No se pudo conectar con el servidor'
            }
          }
        })
  }
}